import { append, none, propEq, when } from 'ramda';
import { setFilterItemStatusActive } from './setFilterItemStatusActive';

export const updateFilterWithNewSport = (filter, sportId) =>
  // prettier-ignore
  when(
    none(propEq(sportId, 'sportId')),
    append(setFilterItemStatusActive({ sportId }))
  )(filter);
